// extracted by mini-css-extract-plugin
module.exports =  {"cad-vlist":"CADList-module__cad-vlist___PssAP"};